import { render, staticRenderFns } from "./addModal.vue?vue&type=template&id=e4fe52f8"
import script from "./addModal.vue?vue&type=script&lang=js"
export * from "./addModal.vue?vue&type=script&lang=js"
import style0 from "./addModal.vue?vue&type=style&index=0&id=e4fe52f8&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e4fe52f8')) {
      api.createRecord('e4fe52f8', component.options)
    } else {
      api.reload('e4fe52f8', component.options)
    }
    module.hot.accept("./addModal.vue?vue&type=template&id=e4fe52f8", function () {
      api.rerender('e4fe52f8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/examine/typeManage/addModal.vue"
export default component.exports